var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.number),function(n,i){return _c('div',{key:i,staticClass:"mb-3 skeleton__shimmer",class:[("h-" + _vm.height)]})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }